<template>
  <!-- App.vue -->

  <v-app>
    <!-- Sizes your content based upon application components -->
    <!-- Provides the application the proper gutter -->
    <layout-content>
      <v-container fluid>
        <!-- If using vue-router -->
        <v-slide-y-transition>
          <router-view></router-view>
        </v-slide-y-transition>
      </v-container>
    </layout-content>
  </v-app>
</template>

<script>
import LayoutContent from "@/layouts/Content.vue";

export default {
  components: {
    "layout-content": LayoutContent,
  },

  name: "App",
};
</script>
